import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const BrandStaffDepartmentSchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
});
